@if (showSpinner) {
<app-loader> </app-loader>
}
<div class="main-wrapper">
  <div class="inner-section-announcement"
    [ngClass]="{'grid-active': viewType === 'grid', 'list-active': viewType === 'list'}">
    <div class="inner-wrapper">
      <div class="announcement-top">
        <p class="heading-announcement">Announcement</p>
        <div class="add-section-main">
          @if (adminCheck) {
          <div class="media-icon" [routerLink]="['/news-update-gallery']">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6 1.5H2.83333C2.36662 1.5 2.13327 1.5 1.95501 1.59083C1.79821 1.67072 1.67072 1.79821 1.59083 1.95501C1.5 2.13327 1.5 2.36662 1.5 2.83333V6C1.5 6.46671 1.5 6.70007 1.59083 6.87833C1.67072 7.03513 1.79821 7.16261 1.95501 7.24251C2.13327 7.33333 2.36662 7.33333 2.83333 7.33333H6C6.46671 7.33333 6.70007 7.33333 6.87833 7.24251C7.03513 7.16261 7.16261 7.03513 7.24251 6.87833C7.33333 6.70007 7.33333 6.46671 7.33333 6V2.83333C7.33333 2.36662 7.33333 2.13327 7.24251 1.95501C7.16261 1.79821 7.03513 1.67072 6.87833 1.59083C6.70007 1.5 6.46671 1.5 6 1.5Z"
                stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M15.1667 1.5H12C11.5333 1.5 11.2999 1.5 11.1217 1.59083C10.9649 1.67072 10.8374 1.79821 10.7575 1.95501C10.6667 2.13327 10.6667 2.36662 10.6667 2.83333V6C10.6667 6.46671 10.6667 6.70007 10.7575 6.87833C10.8374 7.03513 10.9649 7.16261 11.1217 7.24251C11.2999 7.33333 11.5333 7.33333 12 7.33333H15.1667C15.6334 7.33333 15.8667 7.33333 16.045 7.24251C16.2018 7.16261 16.3293 7.03513 16.4092 6.87833C16.5 6.70007 16.5 6.46671 16.5 6V2.83333C16.5 2.36662 16.5 2.13327 16.4092 1.95501C16.3293 1.79821 16.2018 1.67072 16.045 1.59083C15.8667 1.5 15.6334 1.5 15.1667 1.5Z"
                stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M15.1667 10.6667H12C11.5333 10.6667 11.2999 10.6667 11.1217 10.7575C10.9649 10.8374 10.8374 10.9649 10.7575 11.1217C10.6667 11.2999 10.6667 11.5333 10.6667 12V15.1667C10.6667 15.6334 10.6667 15.8667 10.7575 16.045C10.8374 16.2018 10.9649 16.3293 11.1217 16.4092C11.2999 16.5 11.5333 16.5 12 16.5H15.1667C15.6334 16.5 15.8667 16.5 16.045 16.4092C16.2018 16.3293 16.3293 16.2018 16.4092 16.045C16.5 15.8667 16.5 15.6334 16.5 15.1667V12C16.5 11.5333 16.5 11.2999 16.4092 11.1217C16.3293 10.9649 16.2018 10.8374 16.045 10.7575C15.8667 10.6667 15.6334 10.6667 15.1667 10.6667Z"
                stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M6 10.6667H2.83333C2.36662 10.6667 2.13327 10.6667 1.95501 10.7575C1.79821 10.8374 1.67072 10.9649 1.59083 11.1217C1.5 11.2999 1.5 11.5333 1.5 12V15.1667C1.5 15.6334 1.5 15.8667 1.59083 16.045C1.67072 16.2018 1.79821 16.3293 1.95501 16.4092C2.13327 16.5 2.36662 16.5 2.83333 16.5H6C6.46671 16.5 6.70007 16.5 6.87833 16.4092C7.03513 16.3293 7.16261 16.2018 7.24251 16.045C7.33333 15.8667 7.33333 15.6334 7.33333 15.1667V12C7.33333 11.5333 7.33333 11.2999 7.24251 11.1217C7.16261 10.9649 7.03513 10.8374 6.87833 10.7575C6.70007 10.6667 6.46671 10.6667 6 10.6667Z"
                stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          }
          <div class="filter-img-container" (click)="toggleFilters()">
            <img class="filter-img" src="../../../assets/announcement/filter.svg" alt="filter" />
          </div>
          @if (adminCheck) {
          <button class="add-announcement-button" (click)="goToAddAnnouncement()">
            <img class="add-announcement-icon" src="../../../assets/announcement/addNewAnnouncementIcon.svg" alt="i" />
            Add
            new Announcement</button>
          }

          @if (!adminCheck) {
          <div class="common-left-border-sec">
            <div class="left-tab-buttons">
              <button [class.active]="viewType === 'list'" (click)="setView('list')">
                <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19 8L7 8M19 2L7 2M19 14L7 14M3 8C3 8.55228 2.55228 9 2 9C1.44772 9 1 8.55228 1 8C1 7.44772 1.44772 7 2 7C2.55228 7 3 7.44772 3 8ZM3 2C3 2.55228 2.55228 3 2 3C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1C2.55228 1 3 1.44772 3 2ZM3 14C3 14.5523 2.55228 15 2 15C1.44772 15 1 14.5523 1 14C1 13.4477 1.44772 13 2 13C2.55228 13 3 13.4477 3 14Z"
                    stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
              <button [class.active]="viewType === 'grid'" (click)="setView('grid')">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 1.5H2.83333C2.36662 1.5 2.13327 1.5 1.95501 1.59083C1.79821 1.67072 1.67072 1.79821 1.59083 1.95501C1.5 2.13327 1.5 2.36662 1.5 2.83333V6C1.5 6.46671 1.5 6.70007 1.59083 6.87833C1.67072 7.03513 1.79821 7.16261 1.95501 7.24251C2.13327 7.33333 2.36662 7.33333 2.83333 7.33333H6C6.46671 7.33333 6.70007 7.33333 6.87833 7.24251C7.03513 7.16261 7.16261 7.03513 7.24251 6.87833C7.33333 6.70007 7.33333 6.46671 7.33333 6V2.83333C7.33333 2.36662 7.33333 2.13327 7.24251 1.95501C7.16261 1.79821 7.03513 1.67072 6.87833 1.59083C6.70007 1.5 6.46671 1.5 6 1.5Z"
                    stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M15.1667 1.5H12C11.5333 1.5 11.2999 1.5 11.1217 1.59083C10.9649 1.67072 10.8374 1.79821 10.7575 1.95501C10.6667 2.13327 10.6667 2.36662 10.6667 2.83333V6C10.6667 6.46671 10.6667 6.70007 10.7575 6.87833C10.8374 7.03513 10.9649 7.16261 11.1217 7.24251C11.2999 7.33333 11.5333 7.33333 12 7.33333H15.1667C15.6334 7.33333 15.8667 7.33333 16.045 7.24251C16.2018 7.16261 16.3293 7.03513 16.4092 6.87833C16.5 6.70007 16.5 6.46671 16.5 6V2.83333C16.5 2.36662 16.5 2.13327 16.4092 1.95501C16.3293 1.79821 16.2018 1.67072 16.045 1.59083C15.8667 1.5 15.6334 1.5 15.1667 1.5Z"
                    stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M15.1667 10.6667H12C11.5333 10.6667 11.2999 10.6667 11.1217 10.7575C10.9649 10.8374 10.8374 10.9649 10.7575 11.1217C10.6667 11.2999 10.6667 11.5333 10.6667 12V15.1667C10.6667 15.6334 10.6667 15.8667 10.7575 16.045C10.8374 16.2018 10.9649 16.3293 11.1217 16.4092C11.2999 16.5 11.5333 16.5 12 16.5H15.1667C15.6334 16.5 15.8667 16.5 16.045 16.4092C16.2018 16.3293 16.3293 16.2018 16.4092 16.045C16.5 15.8667 16.5 15.6334 16.5 15.1667V12C16.5 11.5333 16.5 11.2999 16.4092 11.1217C16.3293 10.9649 16.2018 10.8374 16.045 10.7575C15.8667 10.6667 15.6334 10.6667 15.1667 10.6667Z"
                    stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M6 10.6667H2.83333C2.36662 10.6667 2.13327 10.6667 1.95501 10.7575C1.79821 10.8374 1.67072 10.9649 1.59083 11.1217C1.5 11.2999 1.5 11.5333 1.5 12V15.1667C1.5 15.6334 1.5 15.8667 1.59083 16.045C1.67072 16.2018 1.79821 16.3293 1.95501 16.4092C2.13327 16.5 2.36662 16.5 2.83333 16.5H6C6.46671 16.5 6.70007 16.5 6.87833 16.4092C7.03513 16.3293 7.16261 16.2018 7.24251 16.045C7.33333 15.8667 7.33333 15.6334 7.33333 15.1667V12C7.33333 11.5333 7.33333 11.2999 7.24251 11.1217C7.16261 10.9649 7.03513 10.8374 6.87833 10.7575C6.70007 10.6667 6.46671 10.6667 6 10.6667Z"
                    stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          }

        </div>

        <div class="filter-button">
          <!-- only render when showFilters true -->
          @if (showFilters) {
          <div class="filter-fields" @slideToggle>
            <h5 class="filter-heading">Set Filters Here</h5>
            <div class="filter-panel">
              <div class="filter-top">
                <p class="filter-panel-txt">Filters</p>
                @if (selectedCategory || selectedDate || selectedMonth || selectedYear) {
                <a class="filter-reset-all" (click)="resetFilters($event)">Reset All</a>
                }
              </div>
              <p class="info-txt">Please fill the Information to Apply the Filter</p>
              <label for="search" class="search-label">Category</label>
              <div class="search-box">
                <span class="search-icon">
                  <img class="search-img" src="../../../assets/announcement/search-md.svg" alt="filter" />
                </span>
                <input type="text" id="search" placeholder="Search Category" [(ngModel)]="selectedCategory" />
              </div>
              <div class="wrap-dateAndMonth">
                <div class="left-date">
                  <label for="date" class="search-label">Date</label>
                  <!-- Visible formatted input -->
                  <input class="search-date" type="text" [value]="selectedDate | date:'dd MMM yyyy'" readonly
                    (click)="openDatePicker(dateInput)" />
                  <!-- Hidden native date input -->
                  <input #dateInput type="date" class="hidden-date-input" (change)="onDateChange($event)" />
                </div>
                <div class="right-month">
                  <label for="month" class="search-label">Month</label>
                  <div class="custom-dropdown">
                    <div class="select-category" (click)="toggleDropdown('month')">
                      {{ selectedMonth || 'Select Month' }}
                      <span class="arrow">&#9662;</span>
                    </div>
                    @if (openDropdown === 'month') {
                    <div class="dropdown-list">
                      @for (month of months; track month) {
                      <div class="dropdown-item" (click)="selectMonth(month, $event)">
                        {{ month }}
                      </div>
                      }
                    </div>
                    }
                  </div>
                </div>
              </div>
              <label for="year" class="search-label">Year</label>
              <div class="custom-dropdown">
                <div class="select-category" (click)="toggleDropdown('year')">
                  {{ selectedYear || 'Select Year' }}
                  <span class="arrow">&#9662;</span>
                </div>
                @if (openDropdown === 'year') {
                <div class="dropdown-list">
                  <div class="dropdown-item" (click)="selectYear('2025', $event)">2028</div>
                  <div class="dropdown-item" (click)="selectYear('2024', $event)">2027</div>
                  <div class="dropdown-item" (click)="selectYear('2023', $event)">2026</div>
                  <div class="dropdown-item" (click)="selectYear('2025', $event)">2025</div>
                  <div class="dropdown-item" (click)="selectYear('2024', $event)">2024</div>
                  <div class="dropdown-item" (click)="selectYear('2023', $event)">2023</div>
                </div>
                }
              </div>
            </div>
            <button class="search-btn" (click)="applyFilters()">Apply</button>
          </div>
          }
        </div>



      </div>



      <div class="container-announcement">
        <!-- Left Panel -->
        <div class="left-panel">

          @if (viewType === 'list') {
          <app-announcement-view class="inner-sub-component" [announcements]="groupedAnnouncements"
            [activeFilter]="filterStatus" (filterChange)="onFilterChange($event)"></app-announcement-view>
          }

          @if (viewType === 'grid') {
          <app-announcement-grid class="inner-sub-component" [announcements]="announcements"></app-announcement-grid>
          }

        </div>






      </div>
    </div>





  </div>